import React from 'react';
export function Footer() {
  return <footer className="bg-white text-text-secondary py-3 md:py-4 px-4 text-center border-t border-black/5" data-id="element-86">
      <div className="max-w-4xl mx-auto space-y-2 md:space-y-3" data-id="element-87">
        <div data-id="element-88">
          <p className="text-xs md:text-sm font-bold text-text-primary" data-id="element-89">
            © 200 Recetas Inteligentes 15D — Todos los derechos reservados
          </p>
          <p className="text-[10px] md:text-xs mt-1 text-text-secondary/80 font-medium" data-id="element-90">
            Producto digital con acceso inmediato tras el pago.
          </p>
        </div>

        <p className="text-[9px] md:text-[10px] opacity-60 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-91">
          Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
          Además, este sitio no está respaldado por Facebook de Facebook de
          ninguna manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}